import UniversalSearchDropdown from "./UniversalSearchDropdown.vue";

export default UniversalSearchDropdown;
